<template>
    <transition
        name="fade"
        mode="out-in"
    >
        <div
            v-if="showBanner"
            id="dashboard-braze-banner-container"
            class="md:rounded-lg"
        />
    </transition>
</template>

<script lang="ts">
import { subscribeToBrazeBanners } from '@/modules/braze';

export default {
    name: 'DashboardWidgetBrazeBanner',
    computed: {
        showBanner() {
            return document.getElementById('dashboard-braze-banner-container')?.innerHTML !== '';
        },
    },
    mounted() {
        subscribeToBrazeBanners();
    },
};
</script>
